import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../components/custom/custom-toast";
import { STATUS } from "../../../constants/status";
import { STRING_SUB_MENU } from "../../../constants/string";
import { useFetchData } from "../../../hooks/useFetch";
import { Banner } from "../../../models/response/banner";
import { API_BANNER_ROUTER } from "../../../services/api-config";
import { BasePaginateResponse } from "../../../services/base-response";
import { toggleMenuContent } from "../../../store/themeConfigSlice";
import { BannerActionsModal } from "../components/banner-actions-modal";

export const ManagementBannerPage = () => {
  const dispatch = useDispatch();
  dispatch(toggleMenuContent(STRING_SUB_MENU.LIST_BANNER));

  const [banners, setBanners] = useState<Banner[]>([]);

  const { request: getBanners, baseResponse: bannersRes } = useFetchData.Get<BasePaginateResponse<Banner[]>>({
    showScreenLoading: true,
  });

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        page: 1,
        limit: 20,
        status: STATUS.ACTIVE,
      };
      await getBanners({
        endPoint: API_BANNER_ROUTER.API_GET_BANNERS,
        data: params,
      });
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!bannersRes) return;
    if (bannersRes?.data && bannersRes?.status === 200) {
      setBanners(bannersRes.data.list);
    } else {
      showToast({
        message: bannersRes?.message ?? "Không thể tải danh sách banner",
        type: "error",
      });
    }
  }, [bannersRes]);

  return (
    <div className="flex flex-col gap-3">
      <BannerActionsModal dataBanners={banners} />
    </div>
  );
};
